// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_a-0";
export var skeletonCard = "_a-1";